export const formatCountryUrl = (name: string): string => {
	if (!name) return "";
	return name
		.trim()
		.toLowerCase()
		.replace(/^europe\s*-\s*/i, "")
		.replace(/[^a-z0-9\s-]/gi, "")
		.replace(/\s+/g, "-")
		.replace(/-+/g, "-");
};
